/**
 * TemplateController
 * Responsible for selecting available Communications for the context
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('TemplateController', [
    '$scope',
    '$window',
    'Template',
    function($scope, $window, Template){

    /**
     * Define Context Type
     *
     * @type {String}
     */
    $scope.context_type = '';

    /**
     * Define Context ID
     *
     * @type {String}
     */
    $scope.context_id = '';

    // List templates
    $scope.templates = {};
}]);
